import * as React from 'react';
import { HeartIcon, ShareIcon } from '@secretescapes/cauldron';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { ButtonsWrapper, IconsBox } from './InteractionButtons.styles';

interface InteractionButtonsProps {
  saleId: string;
  saleTitle: string;
  isFavourite?: boolean;
  isMobile: boolean;
  shareIconColor?: string;
}

export const InteractionButtons = ({
  saleId,
  saleTitle,
  isFavourite,
  isMobile,
  shareIconColor,
}: InteractionButtonsProps) => {
  const { translations } = useTranslations();

  const Wrapper = isMobile ? IconsBox : ButtonsWrapper;

  return (
    <Wrapper data-testid="interaction-buttons">
      <HeartIcon
        saleId={saleId}
        checked={isFavourite}
        buttonText={isMobile ? '' : i18n('favorites.salepage.addTo.label', [], translations)}
      />
      <ShareIcon title=" " text={saleTitle} isMobile={isMobile} fillColor={shareIconColor ?? ''} />
    </Wrapper>
  );
};
